import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ubxb2bCartItemValidationWarningComponent } from './cart-item-validation-warning.component';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';



@NgModule({
    imports: [
        CommonModule, RouterModule, I18nModule, UrlModule, IconModule,
        Ubxb2bCartItemValidationWarningComponent
    ],
    exports: [
        Ubxb2bCartItemValidationWarningComponent
    ]
})
export class Ubxb2bCartItemValidationWarningModule { }
